import { useEffect } from 'react';
import { useUpdate } from '@bydesign-ui/hooks';
import { useAxis } from './useAxis';
export function useAxisMark(type, value) {
  var update = useUpdate();
  var axis = useAxis(type);
  var offset = axis.getValueOffset(value);
  var selected = axis.isValueSelected(value);
  var precisionValue = axis.formatPrecisionValue(value);
  useEffect(function () {
    axis.addListener('repaint', update);
    return function () {
      return axis.removeListener('repaint', update);
    };
  }, []);
  return {
    offset: offset,
    selected: selected,
    precisionValue: precisionValue,
    dragging: axis.getRegion().getDragging()
  };
}